import React, { useEffect, useState } from "react";
import { registrarApi } from "../../config/api";
import { apiClient, apiFormDataClient } from "../../utils/apiClient";
import "./registrar.scss";

const defaultData = {
  _id: null, Title: "Registrar", Subtitle: "", Name: "", Photo: "", Description: "",
};

const Registrar = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(registrarApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const item = Array.isArray(result.data) ? result.data[0] : result.data;
        if (item) {
          setFormData({
            ...item,
            Photo: item.Photo || "",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching Registrar data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const removePhoto = () => {
    setFormData(p => ({ ...p, Photo: "" }));
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${registrarApi}/${formData._id}` : registrarApi;

      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        if (key !== 'Photo' && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });

      if (selectedFile) {
        formDataToSend.append('Photo', selectedFile);
      } else if (formData.Photo) {
        formDataToSend.append('Photo', formData.Photo);
      }

      const response = await apiFormDataClient(url, {
        method,
        body: formDataToSend,
      });

      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        setSelectedFile(null);
        setPreviewUrl(null);
        fetchData();
      }
    } catch (error) {
      console.error("Error saving Registrar data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reg-page">
      <div className="reg-page__header">
        <div><h1>Legal Head</h1><p>Update the Legal Head's official profile, including their name, photo, and professional statement for the institution's portal.</p></div>
        <button className="save-btn" type="submit" form="regForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save Changes"}</button>
      </div>

      <form id="regForm" className="reg-form" onSubmit={handleSubmit}>
        <div className="reg-card">
          <div className="form-section-label">Official Page Configuration</div>
          <div className="form-row">
            <div className="form-group"><label>Page Title</label><input type="text" name="Title" value={formData.Title} onChange={handleChange} placeholder="e.g. Registrar" required /></div>
            <div className="form-group"><label>Subtitle</label><input type="text" name="Subtitle" value={formData.Subtitle} onChange={handleChange} placeholder="e.g. Message to Students & Staff" /></div>
          </div>

          <div className="form-section-label">Professional Info</div>
          <div className="form-group">
            <label>Profile Portrait</label>
            <div className="photo-upload-box">
              {(previewUrl || formData.Photo) ? (
                <div className="photo-preview-wrapper">
                  <img src={previewUrl || formData.Photo} alt="Preview" className="photo-preview" />
                  <div className="photo-actions">
                    <label className="photo-change-btn">Change Photo<input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} /></label>
                    <button type="button" className="photo-remove-btn" onClick={removePhoto}>Remove Photo</button>
                  </div>
                </div>
              ) : (
                <div className="photo-upload-placeholder">
                  <label className="file-upload-label">
                    <div className="upload-icon">📷</div>
                    <span>Click to upload official portrait</span>
                    <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
                  </label>
                  <small>Supported formats: JPG, PNG, WEBP</small>
                </div>
              )}
            </div>
          </div>

          <div className="form-group"><label>Full Name</label><input type="text" name="Name" value={formData.Name} onChange={handleChange} placeholder="Enter full name" required /></div>
          <div className="form-group"><label>Professional Statement</label><textarea name="Description" rows="12" value={formData.Description} onChange={handleChange} placeholder="Type the registrar's official message or profile description here..." required /></div>
        </div>
      </form>
    </div>
  );
};

export default Registrar;